// extracted by mini-css-extract-plugin
export default {"otherPlansRow":"OtherPlans_otherPlansRow__M3aPV","textArea":"OtherPlans_textArea__dwHDZ"};